import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Col, Row, Layout, Button } from 'antd';
import {
  DownloadOutlined,
  HomeFilled,
  SearchOutlined,
} from '@ant-design/icons';
import { ThemeContext } from '../Context/ThemeContext';
import * as pwa from '../../installPWA';
import { ExploreContext } from '../Context/ExploreContext';

const { Header } = Layout;
const { Text } = Typography;

export default function ExploreHeader(props) {
  const history = useHistory();
  const { theme } = useContext(ThemeContext);
  const { searchContent, setSearchContent } = useContext(ExploreContext);

  const handleSearchClick = () => {
    setSearchContent({ ...searchContent, show: !searchContent.show });
  };
  return (
    <div>
      <Header
        style={{
          background: theme.header.bg,
          position: 'fixed',
          zIndex: 1,
          width: '100%',
        }}
      >
        <Row>
          <Col xs={0} sm={0} md={4} lg={6} />
          <Col xs={24} sm={24} md={16} lg={12}>
            <Row>
              <Col xs={14} sm={18}>
                <Text
                  style={{
                    color: theme.header.text,
                    fontSize: '20px',
                  }}
                >
                  Explore People
                </Text>
              </Col>
              {/* Installation */}
              <Col
                xs={4}
                sm={2}
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <Text
                  style={{
                    color: theme.header.text,
                    textAlign: 'right',
                  }}
                  onClick={pwa.install}
                >
                  <Button
                    className='install-app-button install-app-container hidden'
                    size='large'
                    shape='circle-outline'
                    type={theme.label === 'Dark' ? 'primary' : 'default'}
                    title='Install App'
                  >
                    <DownloadOutlined />
                  </Button>
                </Text>
              </Col>
              {/* Search */}
              <Col
                xs={4}
                sm={2}
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <Text
                  style={{
                    color: theme.header.text,
                    textAlign: 'right',
                  }}
                  onClick={handleSearchClick}
                >
                  <Button
                    size='large'
                    shape='circle-outline'
                    type={theme.label === 'Dark' ? 'primary' : 'default'}
                    title='Search'
                  >
                    <SearchOutlined />
                  </Button>
                </Text>
              </Col>
              <Col
                xs={2}
                sm={2}
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <Text
                  style={{
                    color: theme.header.text,
                    textAlign: 'right',
                  }}
                  onClick={() => {
                    history.push('/');
                  }}
                >
                  <Button
                    size='large'
                    shape='circle-outline'
                    type={theme.label === 'Dark' ? 'primary' : 'default'}
                    title='Home'
                  >
                    <HomeFilled />
                  </Button>
                </Text>
              </Col>
              <Col sm={0} md={4} lg={6} />
            </Row>
          </Col>
          <Col xs={0} sm={0} md={4} lg={6} />
        </Row>
      </Header>
    </div>
  );
}
